import { SVGProps } from 'react';
import { ReactComponent } from 'icons/caret-left.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const CaretLeftIcon = (props: Props) => {
  return <ReactComponent className="merc-icon-caret-left" {...props} />;
};
